import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import APIEndpoints from 'src/Admin/api/APIEndpoints';
import ToastMessage from 'src/Admin/components/common/ToastMessage';
import GenericButton from 'src/Admin/components/common/button';
import { ApprovalIcons } from 'src/Admin/img/GlobalSVG';
import { axiosInstance } from 'src/api/axios';

const ApproveButton = ({
  onClick,
  className,
  themeValuesObject,
  isFromDetailsPage,
}) => {
  return (
    <GenericButton
      className={`mr-2 approve-button ${className}`}
      variant={isFromDetailsPage ? 'primary' : 'secondary'}
      onClick={onClick}
    >
      <>
        {!isFromDetailsPage ? (
          <ApprovalIcons.RightSign
            fillColor={themeValuesObject['Secondary-1']}
            className={'mr-1'}
          />
        ) : null}
        Approve
      </>
    </GenericButton>
  );
};

const DenyButton = ({
  onClick,
  className,
  themeValuesObject,
  isFromDetailsPage,
}) => {
  return (
    <GenericButton
      className={` deny-button ${className}`}
      variant={isFromDetailsPage ? 'error-secondary' : 'secondary'}
      onClick={onClick}
    >
      <>
        {!isFromDetailsPage ? (
          <ApprovalIcons.CrossSign
            fillColor={themeValuesObject['Secondary-1']}
            className={'mr-1'}
          />
        ) : null}
        Deny
      </>
    </GenericButton>
  );
};

export const ApproveDenyButtons = ({
  isAffiliationRequest = false,
  isFromDetailsPage = false,
  worklistOid,
  enrollmentOid,
  name,
}) => {
  const { themeValuesObject } = useSelector(({ theme }) => theme) || {};

  //Helper to handle approve/deny requests
  const handleRequest = async (action) => {
    try {
      if (isAffiliationRequest) {
        await axiosInstance.post(
          `${
            action === 'approve'
              ? APIEndpoints.dualCoverageApprove()
              : APIEndpoints.dualCoverageDenied()
          }/${worklistOid}`,
        );
      } else {
        await axiosInstance.post(
          `${APIEndpoints.approveEnrollmentRequest()}worklistoid/${worklistOid}/enrollmentoid/${enrollmentOid}/status/${
            action === 'approve' ? 'Approved' : 'Denied'
          }`,
        );
      }
      toast.success(
        <ToastMessage
          type="success"
          subTitle={`${
            isAffiliationRequest ? 'Affiliation' : 'Enrollment'
          } request for ${name} has been ${
            action === 'approve' ? 'approved' : 'denied'
          }!`}
        />,
      );
    } catch (error) {
      toast.error(
        <ToastMessage
          type="error"
          subTitle={`${
            isAffiliationRequest ? 'Affiliation' : 'Enrollment'
          } request for ${name} could not be ${
            action === 'approve' ? 'approved' : 'denied'
          } at the moment! Try again later.`}
        />,
      );
    }
  };

  const approveRequest = () => handleRequest('approve');
  const denyRequest = () => handleRequest('deny');

  return (
    <div className="approve-deny-buttons">
      {isFromDetailsPage ? (
        <>
          <DenyButton
            className={'mr-3'}
            isFromDetailsPage={isFromDetailsPage}
            themeValuesObject={themeValuesObject}
            onClick={denyRequest}
          />
          <ApproveButton
            className={'mr-0'}
            isFromDetailsPage={isFromDetailsPage}
            themeValuesObject={themeValuesObject}
            onClick={approveRequest}
          />
        </>
      ) : (
        <>
          <ApproveButton
            className={'height-32'}
            isFromDetailsPage={isFromDetailsPage}
            themeValuesObject={themeValuesObject}
            onClick={approveRequest}
          />
          <DenyButton
            className={'height-32'}
            isFromDetailsPage={isFromDetailsPage}
            themeValuesObject={themeValuesObject}
            onClick={denyRequest}
          />
        </>
      )}
    </div>
  );
};
